import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  PageBootstrap,
  Footer,
} from '../../components';
import config from '../../config';
import "./TermsOfServicePage.scss"
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import metaImage from '../../assets/ogp.jpg';

const TermsOfServicePageComponent = props => {
  const { scrollingDisabled, intl } = props;
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'TermsOfServicePage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'TermsOfServicePage.schemaDescription' });
  const schemaImage = `${config.canonicalRootURL}${metaImage}`;

  return (
    <PageBootstrap
    description={schemaDescription}
    title={schemaTitle}
    facebookImages={[{ url: metaImage, width: 1200, height: 630 }]}
    twitterImages={[{ url: `${config.canonicalRootURL}${metaImage}`, width: 600, height: 314 }]}
    schema={{
      '@context': 'http://schema.org',
      '@type': 'PrivacyPolicyPage',
      description: schemaDescription,
      name: schemaTitle,
      image: [schemaImage],
    }}
  >
    <TopbarContainer />
    <nav className="secondbar">
      <Row className="inner d-flex flex-row">
        <Col lg="auto" md="auto" sm="auto" xs="auto">
          <p className="page-title align-items-center justify-content-start">
              Terms of Service
          </p>
        </Col>
      </Row>
    </nav>

    <Container fluid className="content">

      <Row>
        <Col>
          <h1 className="title mt-4 mb-2">Kammui利用規約</h1>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第1条 （本規約）</p>
          <p className="infoTextIndented mb-4">
            1. 利用者は、株式会社KAMMUI（以下「カムイ」という）が提供するポータルサイトサービス「Kammui.com」を通じて、自然体験プログラムの主催者（以下、「主催者」といいます。）が提供する、さまざまな自然体験・自然体験・ガイドサービス・ネイチャープログラム（以下、「自然体験」といいます。）の予約、支払い、および体験をします。
          </p>
          <p className="infoTextIndented mb-4">
            2. 利用者は前項の予約を行うにあたり、Kammui利用規約（以下、「本規約」といいます。）に同意しアカウントを開設します。
          </p>
          <p className="infoTextIndented mb-4">
            3. 本規約の文言にて、利用者と自然体験プログラムの主催者の間で、契約が成立します（以下、「本契約」といいます。）。なお、カムイは本契約の当事者とはなりません。
          </p>
          <p className="infoTextIndented mb-4">
            4. 利用者は、主催者から別途提示されるガイドライン等（以下、「ガイドライン等」といいます。）についても、これを遵守するものとします。この場合、ガイドライン等と本契約の間で齟齬がある場合は、本契約が優先して適用されます。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第2条 （カムイ	メンバーシップ登録）</p>
          <p className="infoTextIndented mb-4">
            1. 利用者は、所定の情報を記入してご自身のアカウントを開設します。
          </p>
          <p className="infoTextIndented mb-4">
            2. 利用者は、ご自身が利用する目的以外では、アカウントを作成できません。
          </p>
          <p className="infoTextIndented mb-4">
            3. 当社は、利用者がカムイのコミュニティにとって適切なメンバーであることを確認するために審査を行うことがあります。
          </p>
          <p className="infoTextIndented mb-4">
            4. 提供いただいたすべての個人情報は、当社のプライバシーポリシーに従って収集および処理されます。
          </p>
          <p className="infoTextIndented mb-4">
            5. 利用者は、登録情報を常に正しいものにアップデートする必要があります。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第3条 （予約の方法）</p>
          <p className="infoTextIndented mb-4">
            1. 利用者は、ポータルサイト「Kammui.com」（以下、「本ポータルサイト」といいます。）で自身のアカウントにログインを行い、本ポータルサイトに掲載されている自然体験を選択します。
          </p>
          <p className="infoTextIndented mb-4">
            2. 利用者は、本規約に同意するとともに、申込画面において、必要な項目につき正確な情報を登録し、予約を行います。
          </p>
          <p className="infoTextIndented mb-4" >
            3. 利用者に、予約確認メールが送付された時点で、利用者と申込を行った自然体験の主催者の間で本規約と同じ文言の契約が締結されたとみなされます。
          </p>
          <p className="infoTextIndented mb-4">
            4. 利用者が未成年の場合は、法定代理人の同意を得るものとします。
          </p>
          <p className="infoTextIndented mb-4">
            5. 本ポータルサイトの決済システムは、主催者の委託先であるStripe Japan（以下、「決済代行会社」といいます。）が提供するものとし、利用者はこれを了承します。
          </p>
          <p className="infoTextIndented mb-4">
            6. 予約のキャンセルポリシーについては、本ポータルサイトにおいて別途、定めるものとします。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第4条 （利用者の参加条件）</p>
          <p className="infoTextIndented mb-4">
            1. 利用者が以下の各号に該当する場合、自然体験の申込みはできません。
          </p>
          <p className="infoTextIndented_level2 mb-4">
            ①	糖尿病、高血圧、心臓病、脳障害、てんかん等、自然体験が困難となる疾病をお持ちの方、もしくは、現在治療ないし投薬を受けられている方（但し、担当医の診断書があれば参加可能）<br />
            ②	暴力団、暴力団関係企業、総会屋若しくはこれらに準ずる者又 はその構成員と認められる者<br />
            ③	その他当社または主催者が、利用者が自然体験に参加することは不適切であると判断する場合<br />
          </p>
          <p className="infoTextIndented mb-4">
            2. 当社または主催者は、利用者が前項に該当する場合は、自然体験の開始前もしくは開始後であっても、自然体験の参加を中止します。
          </p>
        </Col>
      </Row>
      
      <Row>
        <Col>
          <p className="infoTitleText mt-4">第5条 （自然体験の中止・変更と返金について）</p>
          <p className="infoTextIndented mb-4">
            1. 利用者の安全のため、天候その他の事情により、自然体験の開始前もしくは開始後であっても当該自然体験を中止あるいは行程・日程を変更することがあります。この場合、中止・変更の判断は主催者側において行います。
          </p>
          <p className="infoTextIndented mb-4">
            2. 第１項により当該自然体験の開始前に中止が決定したときは、原則利用者から受領済の料金について、自然体験の実施のために主催者が負担した実費（ガイドの交通費、使用料金等）を控除した後、自然体験参加人数で按分した金額を返金いたします。但し、自然体験の当日に中止と判断された場合には、申込料相当額については原則返金することができません。
          </p>
          <p className="infoTextIndented mb-4">
            3. 自然体験の開始後に中止・変更が決定したときは、主催者側の判断で返金額を決定いたします。
          </p>
          <p className="infoTextIndented mb-4">
            4. なお、返金がされる場合は、決済代行会社が提供する決済システムにより行われます。この場合、振り込み手数料は利用者負担になります。
          </p>
          <p className="infoTextIndented mb-4">
            5. 返金に関して問題またはクレームがある場合は、利用者と主催者の間で直接解決するものとし、当社は一切の責任を負わないものとします。
          </p>    
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第6条 （主催者の義務）</p>
          <p className="infoTextIndented mb-4">
            1. 主催者は、アウトドアに関して専門的知識を有するものとして一般的に期待されるようなレベルでの善良なる管理者の注意義務をもって、利用者の安全確保に務めます。<br />
          </p>
          <p className="infoTextIndented mb-4">
            2. 主催者は、自然体験を提供する上で、関連する法令を遵守し、自然体験の提供に必要とされる業者登録、ライセンス、認証等を取得しているものとします。<br />
          </p>
          <p className="infoTextIndented mb-4">
            3. 主催者は、利用者との間で発生するすべての問題やクレームについて当事者として解決するものとし、カムイはこれらについて一切の責任を負わないものとします。<br />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第7条 （免責と損害賠償）</p>
          <p className="infoTextIndented mb-4">
            1. 本ポータルサイトに掲載される内容の正確性・適法性・第三者の権利を侵害していないことについては、保証をするものではありません。
          </p>
          <p className="infoTextIndented mb-4">
            2. 本ポータルサイトの利用に必要な、アプリケーション、通信環境、金融機関等のウェブサイトにおける不具合、または通信網の瑕疵、動作不良、不具合、エラー、バグ、所定の使用方法に基づかない使用方法、ハッキングにより、本サービスの想定どおりの機能が履行されず、利用者に不利益や損害が生じた場合においては、当社は一切の責任を負わないものとします。
          </p>
          <p className="infoTextIndented mb-4">
            3. 決済代行会社のシステムの障害や不具合や、金融機関等の振込システムの障害その他決済代行会社や金融機関の都合や判断により主催者に対し本ポータルサイトサービスの全部または一部を提供することができない場合、利用者に生じた損害等については、当社は一切責任を負わないものとします。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第8条 （秘密保持及び個人情報の保護）</p>
          <p className="infoTextIndented mb-4">
            1. 利用者は、当社および主催者が定める方法に従って自然体験を行うものとします。
          </p>
          <p className="infoTextIndented mb-4">
            2. 利用者は、自分のアカウントを第三者に使わせることはできません。
          </p>
          <p className="infoTextIndented mb-4">
            3. 利用者は、カムイおよび主催者の信用を失わせる等の不適切な行為をしてはいけません。
          </p> 
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第9条 （秘密保持及び個人情報の保護）</p>
          <p className="infoTextIndented mb-4">
            1. 主催者は、利用者が自然体験の予約及び参加するにあたり、利用者から受領する個人情報を、個人情報保護法および関連するガイドラインに従って適切に管理するものとします。
          </p>
          <p className="infoTextIndented mb-4">
            2.	主催者は、受領した個人情報を、本サービスの利用目的を超えて第三者に開示し、または漏えいしないものとします。ただし、次の場合はこの限りではありません。<br />
          </p>
          <p className="infoTextIndented_level2 mb-4">
            (1)	利用者の行為が第三者に不利益を及ぼすと判断した場合、当該利用者の登録内容を当該第三者や警察または関係諸機関に通知すること<br />
            (2)	裁判所、検察庁、警察、弁護士会、消費者センターまたはこれらに準じた権限を有する機関から、特定の利用者の登録内容についての開示を求められた場合、これに応じてその利用者の登録内容を当該機関に開示すること<br />
            (3)	主催者が自然体験を提供するために必要な委託先または提携先<br />
            (4)	その他個人情報保護法及び他の法令に定める場合<br />
          </p>
          <p className="infoTextIndented mb-4">
            3. 利用者は、主催者に提供する個人情報が必要な範囲で、カムイおよび決済代行会社に提供されることに合意します。カムイおよび決済代行業者は、プライバシーポリシーに従って適切に個人情報を管理します。<br />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第10条	（カムイによる終了）</p>
          <p className="infoTextIndented mb-4">
            1. 当社は、利用者が以下に該当する場合またはそのおそれがある場合は、直ちに利用者のアカウントを解約し、かつ参加（予約を含みます）している自然体験を中止できます。
          </p>
          <p className="infoTextIndented_level2 mb-4">
            (1)	利用者のサービス利用が、不正または詐欺的な使用を疑う合理的な理由がある場合<br />
            (2)	利用者が本規約を遵守していない（料金の支払期日が到来していないことを含む）と当社が合理的に判断した場合<br />
            (3)	利用者が当社に推薦した他の会員が、犯罪またはその他の不正な目的を犯したと判明した場合<br />
            (4)	利用者による機密保持の違反または当社の知的財産権の侵害を合理的に疑う場合<br />
          </p>
          <p className="infoTextIndented mb-4">
            2. 第１項に基づいて主催者が本契約を解除した場合は、既に受領済みの申込金については利用者に返還いたしません。<br />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第11条	（権利帰属）</p>
          <p className="infoTextIndented mb-4">
            1. 当社ポータルサイトに表示される全てのコンテンツは、著作権上の保護を受けています。
          </p>
          <p className="infoTextIndented mb-4">
            2. 利用者は当該コンテンツを無断で、複製、公開、送信、頒布、譲渡、貸与、使用許諾、転載、再利用してはいけません。<br />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第12条	（本規約の変更・改訂について）</p>
          <p className="infoTextIndented mb-4">
            1. 本規約は、事前の通知によりいつでも変更されるものとし、利用者は予めこれを承諾するものとします。
          </p>
          <p className="infoTextIndented mb-4">
            2. 本規約の変更後も、継続して本ポータルサイトを利用した場合には、利用者は、当該変更に同意したとみなされます。
          </p>  
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第13条	（準拠法）</p>
          <p className="infoText mb-4">
            本規約の解釈、運用等は、日本国の法令に準拠するものとします。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第14条	（合意管轄）</p>
          <p className="infoText mb-4">
            主催者と利用者との間の一切の訴訟については、東京地裁を第一審の専属的合意管轄裁判所とします。
          </p>
        </Col>
      </Row>
    
      <div className="border-top my-3 separator"></div>

      <Row>
        <Col>
          <h2 className="title mt-4 mb-2">Kammui＋特約</h2>
          <p className="infoTextIndented mb-4">
            Kammui＋サービスを利用する場合には、以下のKammui＋特約（「本特約」）が適用されます。本規約との齟齬がある場合は本特約が優先して適用されます。
          </p>
        </Col>
      </Row>
  
      <Row>
        <Col>
          <p className="infoTitleText mt-4">第1条 Kammui+について</p>
          <p className="infoTextIndented mb-4">
            1. 当社は「Kammui+」サービスとして、ガイドやパートナーとのネットワークを活用し、利用者が希望するような自然体験をカスタマイズし提案するコンシェルジュ型サービス（以下「予約サポート」）を、所定の会費にてKammui+の利用者に提供します。
          </p>
          <p className="infoTextIndented mb-4">
            2. 利用者は予約サービスを利用することにより、限定的な場所、体験、イベントへ参加することができ、また自然体験主催者や当社のパートナーからの割引や特典を利用することができます。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第2条 予約サポートサービス</p>
          <p className="infoTextIndented mb-4">
            1. 利用者は所定の入会金および年会費を支払うことで、Kammui+会員登録を行い、予約サポートを利用できます。
          </p>
          <p className="infoTextIndented mb-4">
            2. 利用者は、予約サポートを申し込む場合は、体験予定日の10日以上前に申し込むものとします（体験予定日を起算日とする）。
          </p>
          <p className="infoTextIndented mb-4">
            3. 利用者は、予約サポートサービスを、1年間において最大12回まで利用することができます。
          </p>
          <p className="infoTextIndented mb-4">
            4. サービスの価格（税金含む）は、お客様が予約を完了する前に当社が通知する価格となります。価格には、Kammuiおよび第三者（第三者のサプライヤーおよび旅行代理店を含むが、これに限定されない）が請求する手数料が含まれる場合があります。
          </p>
          <p className="infoTextIndented mb-4">
            5. 当社のサービスを通じて、利用者はパートナーや小売業者が運営・所有するパートナーウェブサイトにURLにより遷移し、特典等（有料の場合もあります）（以下「パートナー特典」）にアクセスする場合がありますが、Kammuiは利用者が本ポータルから遷移した先については、一切の責任を負いません。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第3条 会費</p>
          <p className="infoTextIndented mb-4">
            1. 利用者は、最初に登録する場合は、入会費と年会費を支払います。
          </p>
          <p className="infoTextIndented mb-4">
            2. 2年目以降は、利用者は所定の年会費を支払います。当社は、必要に応じていつでも年会費を変更することができます。
          </p>
          <p className="infoTextIndented mb-4">
            3. 利用者には、登録または更新する時点で有効な年会費が適用されます。
          </p>
          <p className="infoTextIndented mb-4">
            4. 利用者のメンバーシップは、利用者が登録した日から12ヶ月間有効であり、その後は利用者が更新日の15日前までに所定の退会手続きを行わない限り、1年ごとに自動更新されます。
          </p>
          <p className="infoTextIndented mb-4">
            5. 当社は、独自の裁量で、アカウントの付与または更新を拒否する権利を留保します。この場合、当社は拒否の理由を開示する必要がない旨をご了解ください。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第4条	（カムイによる終了）</p>
          <p className="infoTextIndented mb-4">
            1. 当社は、利用者が以下に該当する場合またはそのおそれがある場合は、直ちに利用者のKammui+アカウントを解約し、かつ参加（予約を含みます）している自然体験を中止できます。
          </p>
          <p className="infoTextIndented_level2 mb-4">
            (1)	利用者のサービス利用が、不正または詐欺的な使用を疑う合理的な理由がある場合<br />
            (2)	利用者が本規約を遵守していない（料金の支払期日が到来していないことを含む）と当社が合理的に判断した場合<br />
            (3)	利用者が当社に推薦した他の会員が、犯罪またはその他の不正な目的を犯したと判明した場合<br />
            (4)	利用者による機密保持の違反または当社の知的財産権の侵害を合理的に疑う場合<br />
          </p>
          <p className="infoTextIndented mb-4">
            2. 第１項に基づいて主催者が本契約を解除した場合は、既に受領済みの申込金については利用者に返還いたしません。<br />
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第5条	（権利帰属）</p>
          <p className="infoTextIndented mb-4">
            1. 当社ポータルサイトに表示される全てのコンテンツは、著作権上の保護を受けています。
          </p>
          <p className="infoTextIndented mb-4">
            2. 利用者は当該コンテンツを無断で、複製、公開、送信、頒布、譲渡、貸与、使用許諾、転載、再利用してはいけません。<br />
          </p> 
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText mt-4">第6条	（本規約の変更・改訂について）</p>
          <p className="infoTextIndented mb-4">
            1. 本特約は、事前の通知によりいつでも変更されるものとし、利用者は予めこれを承諾するものとします。
          </p>
          <p className="infoTextIndented mb-4">
            2. 本特約の変更後も、継続してKammui+を利用した場合には、利用者は、当該変更に同意したとみなされます。
          </p> 
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText">第7条	（準拠法）</p>
          <p className="infoText mb-4">
            本特約の解釈、運用等は、日本国の法令に準拠するものとします。
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="infoTitleText">第8条	（合意管轄）</p>
          <p className="infoText mb-4">
            主催者と利用者との間の一切の訴訟については、東京地裁を第一審の専属的合意管轄裁判所とします。
          </p>

          <p className="updatedTime">2023年　5月　9日 改定</p>
        </Col>
      </Row>

    </Container>

    <Footer />

  </PageBootstrap>
  );
};

const { bool } = PropTypes;

TermsOfServicePageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const TermsOfServicePage = compose(
  connect(mapStateToProps),
  injectIntl
)(TermsOfServicePageComponent);

export default TermsOfServicePage;
